export const dummyData = {
    canvassResults: {
        overview: {
            canvasses: "44",
            average_reception: "4.39",
            houses: "14",
            queries: "0",
            surveys: "3",
            hitrate: "70.4545",
        },
        canvassesOverTime: [
            {
                key: "Interactions",
                values: [
                    {
                        x: 1,
                        y: 0,
                        date: "2019-02-24",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 2,
                        y: 0,
                        date: "2019-02-25",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 3,
                        y: 3,
                        date: "2019-02-26",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 4,
                        y: 0,
                        date: "2019-02-27",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 5,
                        y: 0,
                        date: "2019-02-28",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 6,
                        y: 0,
                        date: "2019-03-01",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 7,
                        y: 0,
                        date: "2019-03-02",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 8,
                        y: 10,
                        date: "2019-03-03",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 9,
                        y: 0,
                        date: "2019-03-04",
                        series: 0,
                        color: "#007fa3",
                    },
                    {
                        x: 10,
                        y: 0,
                        date: "2019-03-05",
                        series: 0,
                        color: "#007fa3",
                    },
                ],
                type: "line",
                yAxis: 1,
                originalKey: "Canvasses",
            },
            {
                key: "Locations",
                values: [
                    {
                        x: 1,
                        y: 0,
                        date: "2019-02-24",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 2,
                        y: 0,
                        date: "2019-02-25",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 3,
                        y: 2,
                        date: "2019-02-26",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 4,
                        y: 0,
                        date: "2019-02-27",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 5,
                        y: 0,
                        date: "2019-02-28",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 6,
                        y: 0,
                        date: "2019-03-01",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 7,
                        y: 0,
                        date: "2019-03-02",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 8,
                        y: 9,
                        date: "2019-03-03",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 9,
                        y: 0,
                        date: "2019-03-04",
                        series: 1,
                        color: "#a5d8d8",
                    },
                    {
                        x: 10,
                        y: 0,
                        date: "2019-03-05",
                        series: 1,
                        color: "#a5d8d8",
                    },
                ],
                type: "line",
                yAxis: 1,
                originalKey: "Locations",
            },
            {
                key: "Avg. Rating (right axis)",
                values: [
                    {
                        x: 1,
                        y: 4.75,
                        date: "2019-02-24",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 2,
                        y: 4.75,
                        date: "2019-02-25",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 3,
                        y: 4.0,
                        date: "2019-02-26",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 4,
                        y: 4.25,
                        date: "2019-03-27",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 5,
                        y: 4.25,
                        date: "2019-03-28",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 6,
                        y: 4.25,
                        date: "2019-04-01",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 7,
                        y: 4.25,
                        date: "2019-04-02",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 8,
                        y: 5.0,
                        date: "2019-03-03",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 9,
                        y: 5.0,
                        date: "2019-03-04",
                        series: 0,
                        color: "#ffcf53",
                    },
                    {
                        x: 10,
                        y: 5.0,
                        date: "2019-03-05",
                        series: 0,
                        color: "#ffcf53",
                    },
                ],
                type: "line",
                yAxis: 2,
                originalKey: "Avg. Rating",
            },
        ],
        types: [
            {
                count: "31",
                label: "Answered",
            },
            {
                count: "7",
                label: "Call Back",
            },
            {
                count: "4",
                label: "Not Home",
            },
            {
                count: "2",
                label: "Not Interested",
            },
        ],
        reception: [
            {
                count: "1",
                label: "1 Star",
            },
            {
                count: "7",
                label: "2 Star",
            },
            {
                count: "4",
                label: "3 Star",
            },
            {
                count: "2",
                label: "4 Star",
            },
            {
                count: "30",
                label: "5 Star",
            },
        ],
        group: [
            {
                id: "82",
                effortid: "1",
                timestamp: "2019-04-29 03:52:22",
                gid: "1",
                canvasses: "80",
                housesvisited: "72",
                "0starcanvasses": "1",
                "1starcanvasses": "8",
                "2starcanvasses": "0",
                "3starcanvasses": "68",
                "4starcanvasses": "9",
                "5starcanvasses": "1",
                size: "1",
                apptype: "Walk",
                gname: "Potential Volunteers",
                gcreator: "106482",
                gstatus: "Active",
                gtimestamp: "2019-04-28 04:18:58",
                gcreationdatetime: "2019-04-28 04:18:58",
                tid: null,
                gpolygon: null,
                hitrate: "50.0000",
                avg_reception: "3.1400",
            },
            {
                id: "83",
                effortid: "1",
                timestamp: "2019-04-29 03:52:22",
                gid: "2",
                canvasses: "109",
                housesvisited: "72",
                "0starcanvasses": "1",
                "1starcanvasses": "8",
                "2starcanvasses": "0",
                "3starcanvasses": "8",
                "4starcanvasses": "9",
                "5starcanvasses": "99",
                size: "2",
                apptype: "Walk",
                gname: "Supporters",
                gcreator: "106482",
                gstatus: "Active",
                gtimestamp: "2019-03-19 23:22:34",
                gcreationdatetime: "2019-03-19 23:22:09",
                tid: "1",
                gpolygon: null,
                hitrate: "70.000",
                avg_reception: "4.99",
            },
            {
                id: "84",
                effortid: "1",
                timestamp: "2019-04-29 03:52:22",
                gid: "3",
                canvasses: "80",
                housesvisited: "72",
                "0starcanvasses": "1",
                "1starcanvasses": "8",
                "2starcanvasses": "0",
                "3starcanvasses": "68",
                "4starcanvasses": "9",
                "5starcanvasses": "1",
                size: "1",
                apptype: "Walk",
                gname: "Swing List",
                gcreator: "106482",
                gstatus: "Active",
                gtimestamp: "2019-04-28 04:18:58",
                gcreationdatetime: "2019-04-28 04:18:58",
                tid: null,
                gpolygon: null,
                hitrate: "50.0000",
                avg_reception: "3.1400",
            },
            {
                id: "85",
                effortid: "1",
                timestamp: "2019-04-29 03:52:22",
                gid: "4",
                canvasses: "109",
                housesvisited: "72",
                "0starcanvasses": "1",
                "1starcanvasses": "8",
                "2starcanvasses": "0",
                "3starcanvasses": "8",
                "4starcanvasses": "9",
                "5starcanvasses": "99",
                size: "2",
                apptype: "Walk",
                gname: "Volunteers",
                gcreator: "106482",
                gstatus: "Active",
                gtimestamp: "2019-03-19 23:22:34",
                gcreationdatetime: "2019-03-19 23:22:09",
                tid: "1",
                gpolygon: null,
                hitrate: "70.000",
                avg_reception: "4.99",
            },
            {
                id: "86",
                effortid: "1",
                timestamp: "2019-04-29 03:52:22",
                gid: "5",
                canvasses: "80",
                housesvisited: "72",
                "0starcanvasses": "1",
                "1starcanvasses": "8",
                "2starcanvasses": "0",
                "3starcanvasses": "68",
                "4starcanvasses": "9",
                "5starcanvasses": "1",
                size: "1",
                apptype: "Walk",
                gname: "Email Outreach",
                gcreator: "106482",
                gstatus: "Active",
                gtimestamp: "2019-04-28 04:18:58",
                gcreationdatetime: "2019-04-28 04:18:58",
                tid: null,
                gpolygon: null,
                hitrate: "50.0000",
                avg_reception: "3.1400",
            },
        ],
        street: [
            {
                id: "25667",
                haddress: "10 St Sw",
                hcity: "San Fransico",
                hstate: "California",
                effortid: "1",
                timestamp: "2019-04-29 03:52:22",
                canvasses: "5",
                housesvisited: "2",
                "0starcanvasses": "4",
                "1starcanvasses": "0",
                "2starcanvasses": "0",
                "3starcanvasses": "0",
                "4starcanvasses": "1",
                "5starcanvasses": "0",
                apptype: "Walk",
                size: "20",
                hitrate: "20.0000",
                avg_reception: "4.0000",
            },
            {
                id: "25691",
                haddress: "19 St Sw",
                hcity: "San Fransico",
                hstate: "California",
                effortid: "1",
                timestamp: "2019-04-29 03:52:23",
                canvasses: "3",
                housesvisited: "3",
                "0starcanvasses": "2",
                "1starcanvasses": "0",
                "2starcanvasses": "0",
                "3starcanvasses": "0",
                "4starcanvasses": "0",
                "5starcanvasses": "1",
                apptype: "Walk",
                size: "29",
                hitrate: "33.3333",
                avg_reception: "5.0000",
            },
            {
                id: "25668",
                haddress: "10a St Sw",
                hcity: "San Fransico",
                hstate: "California",
                effortid: "1",
                timestamp: "2019-04-29 03:52:23",
                canvasses: "2",
                housesvisited: "1",
                "0starcanvasses": "2",
                "1starcanvasses": "0",
                "2starcanvasses": "0",
                "3starcanvasses": "0",
                "4starcanvasses": "0",
                "5starcanvasses": "0",
                apptype: "Walk",
                size: "1",
                hitrate: "0.0000",
                avg_reception: null,
            },
            {
                id: "25687",
                haddress: "17 St Sw",
                hcity: "San Fransico",
                hstate: "California",
                effortid: "1",
                timestamp: "2019-04-29 03:52:23",
                canvasses: "2",
                housesvisited: "2",
                "0starcanvasses": "2",
                "1starcanvasses": "0",
                "2starcanvasses": "0",
                "3starcanvasses": "0",
                "4starcanvasses": "0",
                "5starcanvasses": "0",
                apptype: "Walk",
                size: "23",
                hitrate: "0.0000",
                avg_reception: null,
            },
            {
                id: "25680",
                haddress: "15a St Sw",
                hcity: "San Fransico",
                hstate: "California",
                effortid: "1",
                timestamp: "2019-04-29 03:52:23",
                canvasses: "2",
                housesvisited: "2",
                "0starcanvasses": "1",
                "1starcanvasses": "0",
                "2starcanvasses": "0",
                "3starcanvasses": "0",
                "4starcanvasses": "0",
                "5starcanvasses": "1",
                apptype: "Walk",
                size: "21",
                hitrate: "50.0000",
                avg_reception: "5.0000",
            },
        ],
    },
} as const;
